import './App.css';
import React from "react";
import NavBar from './Components/Layouts/NavBar/NavBar';
import About from './Components/Sections/About/About';
import IndustrialServices from './Components/Sections/Services/IndustrialServices';
import MarineServices from './Components/Sections/Services/MarineServices';
import LaserCut from './Components/Sections/LaserCut/LaserCut';
import Contact from './Components/Sections/Contact/Contact';
import Machining from './Components/Sections/Machining/Machining';

function App() {
  const [lang, setLang] = React.useState("TR");

  return (
      <div className="App" id='home'>
        <NavBar setLang={setLang} lang={lang} />
        <section id="about" className='about'><About  lang={lang} /></section>
        <section id="marine-services" className='marine-services'> <MarineServices lang={lang} /> </section>
        <section id="industrial-services" className='industrial-services'> <IndustrialServices lang={lang} /> </section>
        <section id="laser-cut" className='laser-cut'> <LaserCut lang={lang} /> </section>
        <section id="machining" className='machining'> <Machining lang={lang} /> </section>
        <section id="contact" className='contact'> <Contact lang={lang} /> </section>
      </div>
  );
}

export default App;
